import React, { useEffect, useState } from "react";
import { getFetch, postFetch } from "../../../../fetch/fetch";
import useStyles2 from "../money/etc/useStyles";
import { DataGridPremium, GridToolbar } from "@mui/x-data-grid-premium";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import totalLocationData from "../../../../data/locationdata";
import { englishLocationToKorean } from "../../../../data/locationFuntion";
import CustomInput from "../etc/custominput";
import { Button, Modal, ModalDialog } from "@mui/joy";
import { toast } from 'react-toastify';

//보충 링크 발송 API (서버 restaurant.ts /regularmeal/topup/send) - 경로 변경 시 여기만
const TOPUP_SEND_API = "/dashboard/restaurant/regularmeal/topup/send";
//안내 메시지(앱 채팅) 발송 API (서버 envelope.tsx /mealticket-topup-notice, dryRun 겸용)
const TOPUP_NOTICE_API = "/dashboard/envelope/mealticket-topup-notice";
//보충 링크 한 요청당 학생 수 (서버가 결제선생 API 를 순차 호출하므로 postFetch 30초 타임아웃 안에 넉넉히 끝나도록 - 학생당 약 3.7초 여유)
const SEND_CHUNK_SIZE = 8;

//서버 스킵/실패 사유 코드 → 한글
const REASON_KO: any = {
    noUser: "사용자 없음",
    noRemain: "잔액 없음",
    NO_LOCATION_SETTING: "지점 단가 설정 없음",
    TICKET_PRICE_MISMATCH: "보유 단가와 지점 단가 불일치(지점 단가 미전환)",
    INVALID_PRICE: "보충 금액 오류(잔액이 단가 이상)",
    UNPAID_LINK_EXISTS: "미결제 링크 있음(재발송은 경고 확인 후)",
    noPhone: "유효 번호 없음",
    alreadySending: "다른 보충 링크 발송이 진행 중 (잠시 후 새로고침 후 재시도)",
    requestFail: "응답 시간 초과/통신 오류 — 실제 발송 여부 미확인 (새로고침 후 발송 횟수·결제 여부 열 확인)"
};

//년-월-일 시:분 (0 패딩). 서버 DATETIME(ISO) → 로컬 시각
const formatDateTime = (value: any) => {
    if (!value) {
        return "";
    }
    const d = new Date(value);
    if (isNaN(d.getTime())) {
        return "";
    }
    const pad = (n: number) => (n < 10 ? "0" + n : "" + n);
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

const withComma = (value: any) => {
    if (value === null || value === undefined || isNaN(+value)) {
        return "";
    }
    return (+value).toLocaleString();
}

const RegularMealRemain: React.FC<any> = (props) => {

    const classes = useStyles2();
    const [loading, setLoading] = useState<boolean>(false);
    const [rows, setRows] = useState<any[]>([]);
    const [columns, setColumns] = useState<any[]>([
        {
            field: "name",
            headerName: "이름",
            width: 100
        },
        {
            field: "location",
            headerName: "지점",
            width: 90
        },
        {
            field: "amount",
            headerName: "식권 장수",
            width: 90
        },
        {
            field: "remainText",
            headerName: "잔액",
            width: 90
        },
        {
            field: "topUpPriceText",
            headerName: "보충 금액",
            width: 100
        },
        {
            field: "sendCount",
            headerName: "발송 횟수",
            width: 90
        },
        {
            field: "lastSentAtText",
            headerName: "마지막 발송 시각",
            width: 140
        },
        {
            field: "linkStatus",
            headerName: "결제 여부",
            width: 90
        },
        {
            field: "messageCountText",
            headerName: "메시지 발송",
            width: 100
        },
        {
            field: "lastMessageAtText",
            headerName: "마지막 메시지 시각",
            width: 140
        }
    ]);
    //체크된 학생 users.id 배열 (controlled)
    const [rowSelectionModel, setRowSelectionModel] = useState<any[]>([]);
    const [alignment, setAlignment] = React.useState("total");
    const [filterModel, setFilterModel] = React.useState<any>({
        items: [
            { field: 'location', operator: 'contains', value: '', id: 1 },
            { field: 'name', operator: 'contains', value: '', id: 2 },
        ]
    });
    const [name, setName] = useState<string>("");

    //행 클릭 상세
    const [selectedUserId, setSelectedUserId] = useState<number | null>(null);
    const [selectedRow, setSelectedRow] = useState<any>(null);
    const [rows2, setRows2] = useState<any[]>([]);
    const [columns2, setColumns2] = useState<any[]>([
        {
            field: "createdAt",
            headerName: "발송 시각",
            width: 140
        },
        {
            field: "price",
            headerName: "금액",
            width: 90
        },
        {
            field: "sendPhoneNumber",
            headerName: "발송 번호",
            width: 120
        },
        {
            field: "sendStatus",
            headerName: "발송 상태",
            width: 80
        },
        {
            field: "paidStatus",
            headerName: "결제 여부",
            width: 90
        },
        {
            field: "paidAt",
            headerName: "결제 시각",
            width: 140
        }
    ]);
    const [loading2, setLoading2] = useState<boolean>(false);
    const [historyMessageCount, setHistoryMessageCount] = useState<number>(0);
    const [historyLastMessageAt, setHistoryLastMessageAt] = useState<string>("");

    //보충 링크 발송 모달
    const [linkModalOpen, setLinkModalOpen] = useState<boolean>(false);
    const [linkSending, setLinkSending] = useState<boolean>(false);

    //안내 메시지 발송 모달
    const [noticeModalOpen, setNoticeModalOpen] = useState<boolean>(false);
    const [noticePreview, setNoticePreview] = useState<any>(null);
    const [noticePreviewLoading, setNoticePreviewLoading] = useState<boolean>(false);
    const [noticeSending, setNoticeSending] = useState<boolean>(false);

    //학생별 실패/스킵 상세 모달
    const [resultModal, setResultModal] = useState<any>({ open: false, title: "", lines: [] });

    //체크된 행 (숨은 선택 방지를 위해 필터/토글 변경 시 선택은 비움)
    const selectedRows = rows.filter((row: any) => rowSelectionModel.includes(row.id));

    useEffect(() => {
        getList();
    }, []);

    useEffect(() => {

        if (!selectedUserId) {
            return;
        }

        getHistory();
    }, [selectedUserId]);

    const notifySuccess = (message: string) => toast.success(message, {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        theme: "light"
    });

    const notifyError = (message: string) => toast.error(message, {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        theme: "light"
    });

    //잔액(remain>0) 보유 학생 목록 (지점 단가·보충 금액·링크/메시지 발송 집계는 서버 응답에 포함)
    const getList = async () => {

        try {

            setLoading(true);

            const result: any = await getFetch("/dashboard/restaurant/regularmeal/topup/list");

            console.log(result);

            if (result.message === "success") {

                const data = result.data || [];

                const newRows: any[] = [];

                data.forEach((item: any) => {

                    const sendCount = +item.sendCount;
                    const topUpPrice = item.topUpPrice !== null && item.topUpPrice !== undefined ? +item.topUpPrice : null;

                    newRows.push({
                        id: item.id,
                        name: item.name,
                        location: item.location,
                        amount: +item.amount,
                        remain: +item.remain,
                        remainText: withComma(item.remain) + "원",
                        ticketPrice: item.ticketPrice !== null && item.ticketPrice !== undefined ? +item.ticketPrice : null,
                        topUpPrice: topUpPrice,
                        topUpPriceText: topUpPrice === null ? "-" : withComma(topUpPrice) + "원",
                        sendCount: sendCount,
                        unpaidCount: +item.unpaidCount,
                        lastSentAtText: formatDateTime(item.lastSentAt),
                        //마지막 성공 발송 링크 기준
                        linkStatus: sendCount === 0 ? "-" : (item.lastLinkPaid ? "결제완료" : "미결제"),
                        messageCount: +item.messageCount,
                        messageCountText: (+item.messageCount) + "회",
                        lastMessageAtText: item.lastMessageAt ? formatDateTime(item.lastMessageAt) : "-"
                    });
                });

                setRows([...newRows]);

            } else {
                notifyError("목록 조회 실패: " + result.message);
            }

            setLoading(false);

        } catch (e) {
            console.log(e);
            notifyError("목록 조회 실패");
            setLoading(false);
        }
    }

    //선택 학생의 보충 링크 발송 이력 + 안내 메시지 발송 집계
    const getHistory = async () => {

        try {

            setLoading2(true);

            const result: any = await getFetch("/dashboard/restaurant/regularmeal/topup/userdetail?id=" + selectedUserId);

            console.log(result);

            const data = result.data || [];

            const newRows: any[] = [];

            data.forEach((item: any) => {
                newRows.push({
                    id: item.id,
                    createdAt: formatDateTime(item.createdAt),
                    price: withComma(+item.numbers * +(item.pricePerTicket || 0)) + "원",
                    sendPhoneNumber: item.sendPhoneNumber,
                    sendStatus: item.isSendSuccess ? "성공" : "실패",
                    paidStatus: item.isPaid ? "결제완료" : "미결제",
                    paidAt: item.isPaid && item.paidAt ? formatDateTime(item.paidAt) : ""
                });
            });

            setRows2([...newRows]);
            setHistoryMessageCount(result.messageCount !== undefined ? +result.messageCount : 0);
            setHistoryLastMessageAt(result.lastMessageAt ? formatDateTime(result.lastMessageAt) : "");

            setLoading2(false);

        } catch (e) {
            console.log(e);
            setLoading2(false);
        }

    }

    const handleAlignmentChange = (event: React.MouseEvent<HTMLElement>, newAlignment: string) => {

        if (!newAlignment) {
            return;
        }

        const newFilterModel = filterModel;

        if (newAlignment === "total") {

            newFilterModel.items[0].value = "";

        } else {

            const korean = englishLocationToKorean(newAlignment);

            newFilterModel.items[0].value = korean;

        }

        setFilterModel({ ...newFilterModel });
        setAlignment(newAlignment);
        //필터로 숨겨진 행이 선택에 남지 않도록 초기화
        setRowSelectionModel([]);
    }

    const nameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setName(e.target.value);

        const newFilterModel = filterModel;

        newFilterModel.items[1].value = e.target.value;

        setFilterModel({ ...newFilterModel });
        setRowSelectionModel([]);
    }

    //===== 버튼 1: 결제선생 보충 링크 발송 =====

    //보충 금액이 있는 행만 발송 대상 (지점 단가 설정 없음 = null 은 제외)
    const linkSendableRows = selectedRows.filter((row: any) => row.topUpPrice !== null && row.topUpPrice > 0);
    const linkExcludedCount = selectedRows.length - linkSendableRows.length;
    const linkUnpaidRows = linkSendableRows.filter((row: any) => row.unpaidCount > 0);
    const linkTotalPrice = linkSendableRows.reduce((sum: number, row: any) => sum + row.topUpPrice, 0);

    const sendLinks = async () => {

        if (linkSendableRows.length === 0) {
            return;
        }

        try {

            setLinkSending(true);

            //미결제 링크 경고에 표시된 학생만 명시적 재발송으로 서버 가드(UNPAID_LINK_EXISTS)를 건너뜀 - 나머지는 가드 유지
            const forceUserIds: number[] = linkUnpaidRows.map((row: any) => row.id);

            const userIds = linkSendableRows.map((row: any) => row.id);

            var successCount = 0;
            var failCount = 0;
            var skippedCount = 0;
            //응답을 못 받은 청크 (서버는 계속 발송 중일 수 있어 실패로 단정하지 않음)
            var unknownCount = 0;
            var stopped = false;
            const details: any[] = [];

            //서버는 결제선생 API 를 순차 호출하므로 SEND_CHUNK_SIZE 명씩 나눠 순차 요청
            for (let i = 0; i < userIds.length; i += SEND_CHUNK_SIZE) {

                const chunk = userIds.slice(i, i + SEND_CHUNK_SIZE);

                try {

                    const result: any = await postFetch(TOPUP_SEND_API, { userIds: chunk, forceUserIds: forceUserIds.filter((id: number) => chunk.includes(id)) });

                    console.log(result);

                    if (result.message === "success") {
                        successCount += +result.data.success;
                        failCount += +result.data.fail;
                        skippedCount += +result.data.skipped;
                        (result.data.details || []).forEach((each: any) => { details.push(each); });
                    } else {
                        failCount += chunk.length;
                        chunk.forEach((userId: number) => {
                            const row = rows.find((each: any) => each.id === userId);
                            details.push({ userId, name: row ? row.name : userId, status: "fail", reason: result.message });
                        });
                        //다른 발송이 진행 중이면 이후 청크도 같은 결과 → 중단
                        if (result.message === "alreadySending") {
                            stopped = true;
                            break;
                        }
                    }

                } catch (e) {
                    console.log(e);
                    //타임아웃/통신 오류: 서버가 이 청크를 아직 처리 중일 수 있으므로 미확인으로 두고 다음 청크와 병행되지 않게 중단
                    unknownCount += chunk.length;
                    chunk.forEach((userId: number) => {
                        const row = rows.find((each: any) => each.id === userId);
                        details.push({ userId, name: row ? row.name : userId, status: "unknown", reason: "requestFail" });
                    });
                    stopped = true;
                    break;
                }
            }

            if (failCount === 0 && skippedCount === 0 && unknownCount === 0) {
                notifySuccess(`보충 링크 발송 성공 ${successCount}건`);
            } else {
                notifyError(`보충 링크 발송 성공 ${successCount}건 / 실패 ${failCount}건 / 스킵 ${skippedCount}건 / 미확인 ${unknownCount}건${stopped ? " (중단됨 - 새로고침 후 확인)" : ""}`);
                setResultModal({
                    open: true,
                    title: "보충 링크 발송 결과",
                    lines: details
                        .filter((each: any) => each.status !== "success")
                        .map((each: any) => `${each.name}: ${each.status === "fail" ? "실패" : each.status === "unknown" ? "미확인" : "스킵"}${each.reason ? " (" + (REASON_KO[each.reason] ? REASON_KO[each.reason] : each.reason) + ")" : ""}`)
                });
            }

            setLinkModalOpen(false);
            setRowSelectionModel([]);
            setLinkSending(false);
            getList();

        } catch (e) {
            console.log(e);
            notifyError("보충 링크 발송 실패");
            setLinkSending(false);
        }
    }

    //===== 버튼 2: 안내 메시지(앱 채팅) 발송 =====

    //dryRun 으로 대상·본문 미리보기를 받은 뒤 모달 오픈 (실제 발송과 같은 코드 경로라 문구/스킵 사유가 일치)
    const openNoticeModal = async () => {

        if (selectedRows.length === 0) {
            return;
        }

        try {

            setNoticePreviewLoading(true);

            const result: any = await postFetch(TOPUP_NOTICE_API, { userIds: selectedRows.map((row: any) => row.id), dryRun: true });

            console.log(result);

            if (result.message === "success") {
                setNoticePreview(result.data);
                setNoticeModalOpen(true);
            } else {
                notifyError("미리보기 실패: " + result.message);
            }

            setNoticePreviewLoading(false);

        } catch (e) {
            console.log(e);
            notifyError("미리보기 실패");
            setNoticePreviewLoading(false);
        }
    }

    const noticeTargets: any[] = noticePreview && noticePreview.targets ? noticePreview.targets : [];
    const noticeSkipped: any[] = noticePreview && noticePreview.skipped ? noticePreview.skipped : [];
    const noticeParentCount = noticeTargets.reduce((sum: number, each: any) => sum + (+each.parentCount || 0), 0);

    //경고(링크 미발송 / 이미 안내 받음)는 dryRun 발송 대상(targets)에 실제 포함된 학생만 기준 (스킵된 학생 제외)
    const noticeTargetIds: number[] = noticeTargets.map((each: any) => +each.userId);
    const noticeTargetRows = selectedRows.filter((row: any) => noticeTargetIds.includes(+row.id));
    const noticeNoLinkRows = noticeTargetRows.filter((row: any) => row.sendCount === 0);
    const noticeAlreadyRows = noticeTargetRows.filter((row: any) => row.messageCount > 0);

    const sendNotice = async () => {

        if (noticeTargets.length === 0) {
            return;
        }

        try {

            setNoticeSending(true);

            const result: any = await postFetch(TOPUP_NOTICE_API, { userIds: noticeTargets.map((each: any) => each.userId) });

            console.log(result);

            if (result.message === "success") {
                notifySuccess(`안내 메시지 발송 완료: 학생 ${result.data.students}명 + 학부모 계정 ${result.data.parents}명 (채팅 ${result.data.messages}건)`);
                setNoticeModalOpen(false);
                setNoticePreview(null);
                setRowSelectionModel([]);
                getList();
            } else if (result.message === "alreadySending") {
                notifyError("다른 단체 발송이 진행 중입니다. 잠시 후 다시 시도하세요.");
            } else {
                notifyError("안내 메시지 발송 실패: " + result.message);
            }

            setNoticeSending(false);

        } catch (e) {
            console.log(e);
            notifyError("안내 메시지 발송 실패");
            setNoticeSending(false);
        }
    }

    const modalStyle = {
        maxWidth: "560px",
        width: "100%",
        maxHeight: "85vh",
        overflowY: "auto" as const
    };

    return (
        <div>
            <div style={{
                width: "1600px",
                marginTop: "40px"
            }}>
                <div style={{
                    width: "1600px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                }}>
                    <div>
                        <ToggleButtonGroup
                            color="primary"
                            value={alignment}
                            exclusive
                            onChange={handleAlignmentChange}
                        >
                            {
                                props.user && totalLocationData.filter(locationData => locationData.academy.includes(props.user.academy)).map((each, index: number) => (
                                    <ToggleButton value={each.english} key={index}>{each.korean}</ToggleButton>
                                ))
                            }
                        </ToggleButtonGroup>
                        <span style={{
                            marginLeft: "24px"
                        }}>
                            <CustomInput value={name} onChange={nameChange} placeholder="이름을 검색하세요" />
                        </span>
                    </div>
                    <div>
                        <div style={{
                            display: "flex",
                            alignItems: "center"
                        }}>
                            <span style={{
                                marginRight: "20px"
                            }}>
                                선택 {selectedRows.length}명
                            </span>
                            <Button
                                variant="plain"
                                color="neutral"
                                onClick={() => { getList(); }}
                                loading={loading}
                                sx={{ marginRight: "8px" }}
                            >
                                새로고침
                            </Button>
                            {
                                props.user && props.user.todoistApiKey &&
                                <Button
                                    variant="soft"
                                    color="primary"
                                    disabled={linkSendableRows.length === 0}
                                    onClick={() => { setLinkModalOpen(true); }}
                                    loading={linkSending}
                                    sx={{ marginRight: "8px" }}
                                >
                                    결제선생 보충 링크 발송
                                </Button>
                            }
                            {
                                props.user && props.user.todoistApiKey &&
                                <Button
                                    variant="soft"
                                    color="warning"
                                    disabled={selectedRows.length === 0}
                                    onClick={openNoticeModal}
                                    loading={noticePreviewLoading}
                                >
                                    안내 메시지 발송
                                </Button>
                            }
                        </div>
                        <div style={{
                            fontSize: "12px",
                            color: "#888",
                            marginTop: "6px",
                            textAlign: "right"
                        }}>
                            발송 순서: ① 결제선생 보충 링크 발송 → ② 안내 메시지 발송 (앱 채팅, 문구에 '링크를 보내드렸습니다' 포함)
                        </div>
                    </div>
                </div>
            </div>
            <div style={{
                display: "flex",
                alignItems: "flex-start"
            }}>
                <div className={classes.root}
                    style={{
                        width: "1050px",
                        height: "800px",
                        marginTop: "20px"
                    }}
                >
                    <DataGridPremium
                        rows={rows}
                        columns={columns}
                        density="compact"
                        loading={loading}
                        components={{ Toolbar: GridToolbar }}
                        checkboxSelection
                        disableRowSelectionOnClick
                        rowSelectionModel={rowSelectionModel}
                        onRowSelectionModelChange={(model) => {
                            setRowSelectionModel([...model]);
                        }}
                        onRowClick={(params) => {
                            setSelectedUserId(params.row.id);
                            setSelectedRow(params.row);
                        }}
                        filterModel={filterModel}
                        onFilterModelChange={(model) => {
                            setFilterModel(model);
                            setRowSelectionModel([]);
                        }}
                        getCellClassName={(params) => {

                            //미결제 보충 링크가 있으면 결제 여부 강조
                            if (params.field === "linkStatus" && params.row.unpaidCount > 0) {
                                return "redtext"
                            }

                            return ""
                        }}
                    />
                </div>
                <div
                    style={{
                        width: "500px",
                        marginTop: "20px",
                        marginLeft: "50px"
                    }}
                >
                    <div style={{
                        height: "28px",
                        lineHeight: "28px",
                        marginBottom: "8px",
                        fontSize: "14px"
                    }}>
                        {
                            selectedRow
                                ?
                                `${selectedRow.name} · 링크 발송 ${selectedRow.sendCount}회 · 메시지 발송 ${historyMessageCount}회${historyLastMessageAt ? " (마지막 " + historyLastMessageAt + ")" : ""}`
                                :
                                "학생을 클릭하면 보충 링크 발송 이력이 표시됩니다"
                        }
                    </div>
                    <div className={classes.root}
                        style={{
                            width: "500px",
                            height: "764px"
                        }}
                    >
                        <DataGridPremium
                            rows={rows2}
                            columns={columns2}
                            density="compact"
                            loading={loading2}
                            getCellClassName={(params) => {

                                if (params.field === "paidStatus" && params.value === "미결제") {
                                    return "redtext"
                                }

                                return ""
                            }}
                        />
                    </div>
                </div>
            </div>

            {/* 보충 링크 발송 확인 모달 */}
            <Modal open={linkModalOpen} onClose={() => { if (!linkSending) { setLinkModalOpen(false); } }}>
                <ModalDialog sx={modalStyle}>
                    <div style={{ fontSize: "18px", fontWeight: 700, marginBottom: "12px" }}>결제선생 보충 링크 발송</div>
                    <div style={{ fontSize: "14px", lineHeight: "22px" }}>
                        <div>{linkSendableRows.length}명 · 총 {withComma(linkTotalPrice)}원</div>
                        {
                            linkExcludedCount > 0 &&
                            <div style={{ color: "#888" }}>보충 금액을 계산할 수 없는 {linkExcludedCount}명(지점 단가 설정 없음)은 제외됩니다.</div>
                        }
                        {
                            linkUnpaidRows.length > 0 &&
                            <div style={{ color: "#d32f2f", marginTop: "10px" }}>
                                미결제 보충 링크가 이미 있는 학생 {linkUnpaidRows.length}명 — 발송하면 링크가 중복됩니다(재발송).
                                <div style={{ fontSize: "13px", marginTop: "4px" }}>
                                    {linkUnpaidRows.map((row: any) => `${row.name}(${row.unpaidCount}건)`).join(", ")}
                                </div>
                            </div>
                        }
                        <div style={{ color: "#888", marginTop: "10px", fontSize: "13px" }}>
                            발송 번호: 마지막 결제 성공 링크 번호 → 학부모 번호 → 학생 번호 순. 발송 후 ② 안내 메시지를 보내세요.
                        </div>
                    </div>
                    <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "20px" }}>
                        <Button variant="plain" color="neutral" onClick={() => { setLinkModalOpen(false); }} disabled={linkSending} sx={{ marginRight: "8px" }}>
                            취소
                        </Button>
                        <Button variant="solid" color="primary" onClick={sendLinks} loading={linkSending} disabled={linkSendableRows.length === 0}>
                            발송
                        </Button>
                    </div>
                </ModalDialog>
            </Modal>

            {/* 안내 메시지 발송 확인 모달 */}
            <Modal open={noticeModalOpen} onClose={() => { if (!noticeSending) { setNoticeModalOpen(false); } }}>
                <ModalDialog sx={modalStyle}>
                    <div style={{ fontSize: "18px", fontWeight: 700, marginBottom: "12px" }}>안내 메시지 발송 (앱 채팅)</div>
                    <div style={{ fontSize: "14px", lineHeight: "22px" }}>
                        <div>학생 {noticeTargets.length}명 + 연결된 학부모 계정 {noticeParentCount}명 → 각자의 채팅방에 {noticeTargets.length + noticeParentCount}건 발송</div>
                        {
                            noticeSkipped.length > 0 &&
                            <div style={{ color: "#888", marginTop: "6px", fontSize: "13px" }}>
                                발송 제외 {noticeSkipped.length}명: {noticeSkipped.map((each: any) => `${each.name || each.userId}(${each.reason})`).join(", ")}
                            </div>
                        }
                        {
                            noticeNoLinkRows.length > 0 &&
                            <div style={{ color: "#d32f2f", marginTop: "10px" }}>
                                보충 링크를 아직 보내지 않은 학생 {noticeNoLinkRows.length}명 포함 — 문구에 '결제 링크를 보내드렸습니다'가 있으니 링크를 먼저 발송하세요.
                                <div style={{ fontSize: "13px", marginTop: "4px" }}>{noticeNoLinkRows.map((row: any) => row.name).join(", ")}</div>
                            </div>
                        }
                        {
                            noticeAlreadyRows.length > 0 &&
                            <div style={{ color: "#d32f2f", marginTop: "10px" }}>
                                이미 안내 메시지를 받은 학생 {noticeAlreadyRows.length}명 포함 (중복 발송됩니다).
                                <div style={{ fontSize: "13px", marginTop: "4px" }}>{noticeAlreadyRows.map((row: any) => row.name).join(", ")}</div>
                            </div>
                        }
                        {
                            noticeTargets.length > 0 &&
                            <div style={{ marginTop: "12px" }}>
                                <div style={{ fontSize: "13px", color: "#666", marginBottom: "4px" }}>미리보기 ({noticeTargets[0].name})</div>
                                <pre style={{
                                    whiteSpace: "pre-wrap",
                                    fontSize: "13px",
                                    background: "#f5f5f5",
                                    padding: "12px",
                                    borderRadius: "8px",
                                    margin: 0,
                                    fontFamily: "inherit"
                                }}>{noticeTargets[0].text}</pre>
                            </div>
                        }
                        <div style={{ color: "#888", marginTop: "10px", fontSize: "13px" }}>
                            앱 채팅으로 발송됩니다. 학생 본인 방과 연결된 학부모 계정(학부모 계정의 자녀 번호 = 학생 번호)의 방에 각각 들어가며, 학부모 계정이 없는 가정은 학생 앱에서만 확인됩니다.
                        </div>
                    </div>
                    <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "20px" }}>
                        <Button variant="plain" color="neutral" onClick={() => { setNoticeModalOpen(false); }} disabled={noticeSending} sx={{ marginRight: "8px" }}>
                            취소
                        </Button>
                        <Button variant="solid" color="warning" onClick={sendNotice} loading={noticeSending} disabled={noticeTargets.length === 0}>
                            발송
                        </Button>
                    </div>
                </ModalDialog>
            </Modal>

            {/* 학생별 실패/스킵 상세 모달 */}
            <Modal open={resultModal.open} onClose={() => { setResultModal({ ...resultModal, open: false }); }}>
                <ModalDialog sx={modalStyle}>
                    <div style={{ fontSize: "18px", fontWeight: 700, marginBottom: "12px" }}>{resultModal.title}</div>
                    <div style={{ fontSize: "13px", lineHeight: "20px" }}>
                        {
                            resultModal.lines.map((line: string, index: number) => (
                                <div key={index}>{line}</div>
                            ))
                        }
                    </div>
                    <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "20px" }}>
                        <Button variant="solid" color="neutral" onClick={() => { setResultModal({ ...resultModal, open: false }); }}>
                            닫기
                        </Button>
                    </div>
                </ModalDialog>
            </Modal>
        </div>
    )
}

export default RegularMealRemain;
